export default "__VITE_ASSET__529370ed__"